import { useState } from 'react';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import useNewInactiveByReason from '@nkr/store/microsites/hooks/use-new-inactive-by-reason';
import { styles } from './styles';

interface IProps {
    isSuperAdmin: boolean;
    year: number;
    coachId: number;
}

const NewInactiveByReasonModal = ({ isSuperAdmin, year, coachId }: IProps) => {
    const [show, setShow] = useState<boolean>(false);
    const { data, reasons, columns, loading, error, exportData } = useNewInactiveByReason(isSuperAdmin, year, coachId, show);

    const monthsByEventType = new Map(
        (data ?? []).map(row => [row.eventType, row.months])
    );

    return (
        <>
            <Button bsStyle='primary' bsSize='xsmall' style={styles.drillButton} onClick={() => setShow(true)}>R</Button>

            <Modal show={show} onHide={() => setShow(false)} bsSize='large'>
                <Modal.Header closeButton><Modal.Title>New Inactive by Reason</Modal.Title></Modal.Header>
                <Modal.Body>
                    {loading && <Alert bsStyle='info'>Loading...</Alert>}
                    {!loading && error && <Alert bsStyle='danger'>{error}</Alert>}
                    {!loading && !error && (
                        <div style={styles.gridWrapper}>
                            <Table striped condensed bordered>
                                <thead>
                                    <tr>
                                        <th style={styles.compactHeaderCell}>Reason</th>
                                        {columns.map(col => (
                                            <th key={col.key} style={styles.compactHeaderCell}>{col.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {reasons.map(reason => (
                                        <tr key={reason.eventType}>
                                            <td style={styles.compactCell}>{reason.label}</td>
                                            {columns.map(col => (
                                                <td key={col.key} style={styles.compactCell}>
                                                    {(monthsByEventType.get(reason.eventType) ?? {})[col.key] ?? 0}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => exportData()} disabled={!data}>Export</Button>
                    <Button onClick={() => setShow(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default NewInactiveByReasonModal;
